import { render, staticRenderFns } from "./LbTableCheckBox.vue?vue&type=template&id=2b56ea44"
import script from "./LbTableCheckBox.vue?vue&type=script&lang=js"
export * from "./LbTableCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports